import { Brand } from '@common/util-models';
import { createAction, props } from '@ngrx/store';

export const loadBrands = createAction(
  '[Catalog] Load brands for appliance',
  props<{ applianceCode: string }>()
);

export const loadBrandsSuccess = createAction(
  '[Catalog] Brands for appliance loaded successfully',
  props<{ brands: Brand[]; applianceCode: string }>()
);

export const loadBrandsFailure = createAction(
  '[Catalog] Brands for appliance failed',
  props<{ error: Error; applianceCode: string }>()
);
